import { render } from "./Landingpage.vue?vue&type=template&id=3f674b44"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"

import "./Landingpage.vue?vue&type=style&index=0&id=3f674b44&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__